// extracted by mini-css-extract-plugin
module.exports = {"rtl-modal":"ConfirmationModal_rtl-modal__3SKRW","modal-body":"ConfirmationModal_modal-body__2jOB2"};